module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/JtJpoQ/tc-custom/9781439678633.jpg?1717010009963",
      "alt": "This image is the cover for the book Charleston History in Color"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Charleston History in Color\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v(" Charleston Like It's Never Been Seen"), _c('b')])]), _c('p', [_vm._v(" Hand-colored, vivid details bring these historic photographs to life like never before. Witness the beginnings of the sweetgrass basket tradition. See the bleak devastation on Meeting Street after the Civil War. Note intense contrast in blues and grays of prisoners captured at the Battle of Bull Run. Explore the Battery as it looked in the 1800s. And dazzle in the bright fashions of flappers at the dawn of \"the Charleston\" dance craze. Author Mark Jones and artist Lewis Hayes bring a new vision to Holy City history. ")]), _c('p'), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lewis Hayes, Mark R. Jones\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Mark R. Jones is a twenty-year veteran Charleston tour guide and author of eight volumes about South Carolina history, including the Wicked Charleston books. He has conducted more than thirty thousand tours and can be found daily on the Charleston streets. His other writings, including his \"Today in Charleston History\" essays, can be found at Mark-Jones-Books.com. Lewis Hayes is an air force veteran of the first Persian Gulf War and retired fire chief from the Croft Fire Department in Spartanburg, South Carolina. His ancestor served with George Washington and moved to South Carolina in the 1780s. Hayes's passion for history led him to colorizing black-and-white images to illuminate the past.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0